import PropTypes from "prop-types"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { updateState } from "../../../utils/utils"

const ServicesRow = (props) => {
  const {
    showLabel,
    showNumber,
    showDrop,
    label,
    drop,
    setDrop,
    dropError,
    options,
    removeError,
    number,
    setNumber,
    numberError,
    numberErrorType,
    errorsToRemove,
    textInputError,
    summaryDisabled,
    set1,
    set2,
    indentation,
    entity,
    setEntity,
    extraValues,
    defaultZero,
    required
  } = props
  return (
    <div className={gpraStyles.serviceRowContainer}>
      {showLabel && (
        <div className={gpraStyles.col6}>
          <label className={indentation && gpraStyles.ml1}>{label}{required && <span className={gpraStyles.required}> *</span>}</label>
        </div>
      )}
      {showDrop && (
        <div className={gpraStyles.serviceRowDrop}>
          <Dropdown
            className={dropError && gpraStyles.invalid}
            value={drop}
            onChange={(e) => {
              updateState(
                setDrop,
                e.value,
                null,
                null,
                entity,
                setEntity,
                extraValues
              )
              removeError(setDrop)
              if (errorsToRemove) {
                errorsToRemove.forEach((element) => {
                  removeError(element)
                })
              }
              if (set1 && set2) {
                set1(false)
                set2(false)
              }
            }}
            options={options}
            optionLabel="label"
            optionValue="value"
            showClear={drop !== undefined}
            disabled={summaryDisabled}
          />
        </div>
      )}
      {showNumber && (
        <div>
          <InputNumber
            className={gpraStyles.inputNumber}
            inputClassName={numberError && gpraStyles.numberError}
            showButtons
            value={!number && defaultZero ? 0 : number}
            onValueChange={(e) => {
              updateState(
                setNumber,
                e.value,
                null,
                null,
                entity,
                setEntity,
                extraValues
              )
              removeError(numberErrorType)
              if (!e.value) {
                removeError(textInputError)
              }
              if (errorsToRemove) {
                errorsToRemove.forEach((element) => {
                  removeError(element)
                })
              }
            }}
            disabled={summaryDisabled}
            min={0}
            size={7}
          />
        </div>
      )}
      <div>
        {dropError && <FormError error={dropError} type={1} />}
        {numberError && <FormError error={numberError} />}
      </div>
    </div>
  )
}
ServicesRow.propTypes = {
  showNumber: PropTypes.bool,
  showLabel: PropTypes.bool,
  showDrop: PropTypes.bool,
  label: PropTypes.string,
  drop: PropTypes.bool,
  setDrop: PropTypes.string,
  dropError: PropTypes.string,
  options: PropTypes.array,
  removeError: PropTypes.func,
  number: PropTypes.number,
  setNumber: PropTypes.string,
  numberError: PropTypes.string,
  numberErrorType: PropTypes.string,
  errorsToRemove: PropTypes.array,
  textInputError: PropTypes.string,
  summaryDisabled: PropTypes.bool,
  indentation: PropTypes.bool,
}
ServicesRow.defaultProps = {
  showNumber: true,
  showDrop: true,
  showLabel: true,
  extraValues: [],
}
export default ServicesRow
